export function phoneurl(url: string): string {
	if (!url || url === '') return '';
	if (url.startsWith('tel:')) return url;
	return 'tel:' + url;
}

export function weburl(url: string): string {
	if (!url || url === '') return '';
	if (url.startsWith('http:')) {
		return url.replace(/http:/, 'https:');
	}
	if (url.startsWith('https://')) {
		return url;
	}
	return 'https://' + url;
}
